import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import '../styles/Auth.css';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => String(searchParams.get('token') || '').trim(), [searchParams]);

  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [message, setMessage] = useState('');

  const handleConfirm = async () => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid or missing verification token.');
      return;
    }
    setStatus('loading');
    try {
      const response = await authAPI.verifyEmail(token);
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(
          'wikigame:pending-welcome',
          JSON.stringify({
            type: 'email_verified',
            username: response?.data?.username || null,
            at: Date.now(),
          })
        );
      }
      setMessage(response?.data?.message || 'Email verified successfully. You can now log in.');
      setStatus('success');
    } catch (err) {
      setMessage(err?.response?.data?.error || 'Failed to verify email. The link may have expired.');
      setStatus('error');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Email Verification</h2>

        {!token && (
          <p className="error-message">No verification token found. Please use the link from your email.</p>
        )}

        {token && status === 'idle' && (
          <>
            <p>Click the button below to confirm your email address and activate your account.</p>
            <button className="auth-button" onClick={handleConfirm}>
              Confirm my email
            </button>
          </>
        )}

        {status === 'loading' && (
          <p className="success-message">Verifying your account&hellip;</p>
        )}

        {status === 'success' && (
          <p className="success-message">{message}</p>
        )}

        {status === 'error' && (
          <p className="error-message">{message}</p>
        )}

        <p style={{ marginTop: '16px' }}>
          <Link to="/login">Go to login</Link>
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;
